export default __webpack_public_path__ + "static/media/data_configuration_card.da8f49ca.jpg";